import dayjs from 'dayjs'
import startCase from 'lodash/startCase'
import { useHistory } from 'react-router-dom'

import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'

export const PlanCard = ({
  showChangePlanButton = true,
}: {
  showChangePlanButton?: boolean
}) => {
  const { data: network } = useNetwork()
  const history = useHistory()

  return (
    <Card>
      <Card.Header
        title="Plan"
        action={
          showChangePlanButton && (
            <Button
              variant="outline"
              type="button"
              onClick={() => history.push('/manage/settings/billing/plans')}
            >
              Change plan
            </Button>
          )
        }
      />
      <Card.Content>
        <div>
          You are currently on the{' '}
          <b>{startCase(network?.subscriptionPlan?.name)}</b> plan.
        </div>
        {network?.subscriptionPlan?.renewDate && (
          <div>
            Your next billing date is{' '}
            {dayjs(network?.subscriptionPlan?.renewDate).format('MMMM D, YYYY')}
            .
          </div>
        )}
      </Card.Content>
    </Card>
  )
}
